// react-magnetic-di - temporary comment, for auto dependency injection in tests
import { useCallback, useEffect, useRef } from 'react';
import noop from 'lodash/noop';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { fireOperationalEvent } from '@atlassian/ui-modifications-analytics';
import { useViewType } from '../../../../../../controllers/issue-adjustments/hooks/use-view-type';
export var IFRAME_TIMEOUT_DURATION_MS = 12000;
export var useIframeTimeout = function useIframeTimeout(_ref) {
  var forgeExtension = _ref.forgeExtension;
  var timeoutRef = useRef(undefined);
  var callbackRef = useRef(noop);
  var _useAnalyticsEvents = useAnalyticsEvents(),
    createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
  var viewType = useViewType();
  var onTimeout = useCallback(function () {
    var id = forgeExtension.id;
    fireOperationalEvent(createAnalyticsEvent, {
      action: 'failed',
      actionSubject: 'jiraUiModifications.iframeTimeout',
      attributes: {
        timeoutAfter: "".concat(IFRAME_TIMEOUT_DURATION_MS / 1000, "s"),
        extensionId: id,
        viewType: viewType
      }
    });
  }, [forgeExtension, viewType, createAnalyticsEvent]);
  useEffect(function () {
    callbackRef.current = onTimeout;
  }, [onTimeout]);
  var setLoadingComplete = useCallback(function () {
    clearTimeout(timeoutRef.current);
  }, []);
  useEffect(function () {
    // For details on why we need to evaluate the callback in this way, see
    // https://www.joshwcomeau.com/snippets/react-hooks/use-timeout/#explanation
    // tl;dr: it allows the latest version of `onTimeout` to be called, without
    // needing to cancel and start a new timer each time dependencies change
    var callback = function callback() {
      return callbackRef.current();
    };
    timeoutRef.current = setTimeout(callback, IFRAME_TIMEOUT_DURATION_MS);
    return function () {
      return clearTimeout(timeoutRef.current);
    };
  }, []);
  return {
    setLoadingComplete: setLoadingComplete
  };
};